export default "//file.bilionpass.com/japandx-web/0.0.1/static/mine.7a6f77c2-e77a79.svg";